module.exports = __webpack_public_path__ + "img/loader.5e8490b.gif";